module.exports = __webpack_public_path__ + "img/btn_bg_sound_off.777bcec0.svg";